module.exports = {
    GET_ALL_DATA:"GET_ALL_DATA",
    ADD_GOODS:"ADD_GOODS",
    MODIFY_GOODS_NUM:"MODIFY_GOODS_NUM",
    DELETE_GOODS:"DELETE_GOODS",
    Sell_Goods_Success:"Sell_Goods_Success",//出售物品成功
    Compose_Goods_Success: "Compose_Goods_Success",//合成物品成功
    Compose_BackPack_Success: "Compose_BackPack_Success",
}